export const FETCH_ACTIVITYLIST_REQUEST = "FETCH_ACTIVITYLIST_REQUEST";
export const FETCH_ACTIVITYLIST_SUCCESS = "FETCH_ACTIVITYLIST_SUCCESS";
export const FETCH_ACTIVITYLIST_FAILURE = "FETCH_ACTIVITYLIST_FAILURE";
